import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalizationModule } from '@abp/ng.core';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationItemComponent } from '../../models/notification-item-component.model';

/**
 * Fallback renderer used by `notification-type-component.map.ts` for any `NotificationDto.type` without a
 * dedicated component — shows the raw type and payload so unknown notifications are never silently dropped.
 */
@Component({
  selector: 'app-generic-notification',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationModule],
  templateUrl: './generic-notification.component.html',
  styleUrl: './generic-notification.component.scss',
})
export class GenericNotificationComponent implements NotificationItemComponent {
  @Input({ required: true }) notification!: NotificationDto;
}
